"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
function default_1() {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', alignItems: 'center', columnGap: '4px', marginTop: '-1px' } }, { children: [(0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/images/payform_gold_card.webp`, css: { width: '24px', height: '15px' } }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "gray-80", css: { fontSize: '12px' } }, { children: "Pay" }))] })));
}
exports.default = default_1;
